<template>
    <div class="commitment">
			<div class="status">
					<b-card no-body class="p-3">
							<b-row>
									<b-col cols="12" md="4">
											<h4>Loan Information</h4>
											<div class="d-flex align-items-center">
													<h3 class="display-4"
															:class="{'text-muted': commitment.total_issues.loan_information == 0, 'text-primary': commitment.total_issues.loan_information != 0}">
															{{ commitment.total_issues.loan_information || 0 }}
													</h3>
													<small class="ml-1">Issues</small>
											</div>
									</b-col>
									<b-col cols="12" md="4" class="border-right border-left">
											<h4>Missed Payment History</h4>
											<div class="d-flex align-items-center">
													<h3 class="display-4"
															:class="{'text-muted': commitment.total_issues.missed_payment == 0, 'text-primary': commitment.total_issues.missed_payment != 0}">
															{{ commitment.total_issues.missed_payment || 0 }}
													</h3>
													<small class="ml-1">Issues</small>
											</div>
									</b-col>
									<b-col cols="12" md="4">
											<h4>SAA</h4>
											<div class="d-flex align-items-center">
													<h3 class="display-4"
															:class="{'text-muted': commitment.total_issues.special_attension == 0, 'text-primary': commitment.total_issues.special_attension != 0}">
															{{ commitment.total_issues.special_attension || 0 }}
													</h3>
													<small class="ml-1">Issues</small>
											</div>
									</b-col>
							</b-row>
					</b-card>
			</div>
			<div v-if="_gAuth.isAppSas() && (platform == 'CBM')">
				<el-collapse v-model="activeNames" class="border-0" @change="emitEvent">
					<el-collapse-item name="cbm" class="my-3">
						<!-- <div slot="title" class="collapse-header px-3">
							<h3 class="mb-0">CBM</h3>
						</div> -->
						<summary-ccris :summary-ccris="commitment.ccris_summary" :ctosScore="reportData.ctos_score"></summary-ccris>
						<loan-information :loan-information="commitment.commitments"></loan-information>
            <directories :directoriesBusiness="reportData.directorships_business_interests" :addressRecords="reportData.address_records"></directories>
            <liabilities :ccrisBankingRecords="reportData.ccris_banking_records"></liabilities>
            <ccris-supplementary :ccrisSupplementary="reportData.ccris_supplementary"></ccris-supplementary>
            <credit-application :creditApplication="reportData.credit_application"></credit-application>
						<missed-payment-history :missed-payment-history="commitment.missed_payments" :last-commitment="commitmentsWithArrears"></missed-payment-history>
					</el-collapse-item>
					<el-collapse-item name="ctos" class="my-3">
						<!-- <div slot="title" class="collapse-header px-3">
							<h3 class="mb-0">CTOS</h3>
						</div> -->
            <special-attention :special-attention="commitment.special_attensions" :special-attention-resp="reportData.special_attention_resp" ></special-attention>
				   	<akpk-card :akpk-card="commitment.akpk" :akpk-sub-items="akpkSubItems"></akpk-card>
					  <angkasa-report :angkasa-report="commitment.angkasa_reports" :angkasa-report-resp="reportData.angkasa_report_resp"></angkasa-report>
            <legal-sts :legal-sts="commitment.legal_sts" :legal-cases-summary="reportData.legal_cases_summary" :reserve-price="reportData.reserve_price" :platform="platform" :legal-cases-resp="reportData.legal_cases_resp"></legal-sts>
						<legal-cases :legal-cases="commitment.legal_cases" :reserve-price="reportData.reserve_price" :legal-cases-resp="reportData.legal_cases_resp" :legal-cases-summary="reportData.legal_cases_summary"></legal-cases>
						<bankruptcy :bankruptcy="commitment.bankruptcies"  :bankruptcy-legal-cases="bankruptcyLegalCases"></bankruptcy>
            <trade-refferences :trade-refferences="commitment.trade_references" :trade-reference-resp="reportData.trade_reference_resp"></trade-refferences>
            <historical-enquiry :historicalEnquiry="reportData.history"></historical-enquiry>
            <past-enquiry-details :fi="reportData.prev_enquiries_fi" :nonFi="reportData.prev_enquiries_non_fi" :reqNo="reportData.req_no" :userId="reportData.user_id"></past-enquiry-details>
					</el-collapse-item>
				</el-collapse>
			</div>
			<div v-else>
        <summary-ccris :summary-ccris="commitment.ccris_summary" :ctosScore="reportData.ctos_score"></summary-ccris>
        <loan-information :loan-information="commitment.commitments"></loan-information>
        <directories :directoriesBusiness="reportData.directorships_business_interests" :addressRecords="reportData.address_records"></directories>
        <liabilities :ccrisBankingRecords="reportData.ccris_banking_records"></liabilities>
        <ccris-supplementary :ccrisSupplementary="reportData.ccris_supplementary"></ccris-supplementary>
        <special-attention :special-attention="commitment.special_attensions" :special-attention-resp="reportData.special_attention_resp"></special-attention>
        <akpk-card :akpk-card="commitment.akpk" :akpk-sub-items="akpkSubItems"></akpk-card>
        <credit-application :creditApplication="reportData.credit_application"></credit-application>
       	<missed-payment-history :missed-payment-history="commitment.missed_payments" :loan-commitment="commitmentsWithArrears"></missed-payment-history>
        <angkasa-report :angkasa-report="commitment.angkasa_reports" :angkasa-report-resp="reportData.angkasa_report_resp"></angkasa-report>
        <legal-sts :legal-sts="commitment.legal_sts" :legal-cases-summary="reportData.legal_cases_summary" :reserve-price="reportData.reserve_price" :platform="platform" :legal-cases-resp="reportData.legal_cases_resp"></legal-sts>
        <legal-cases :legal-cases="commitment.legal_cases" :reserve-price="reportData.reserve_price" :legal-cases-resp="reportData.legal_cases_resp" :legal-cases-summary="reportData.legal_cases_summary"></legal-cases>
        <bankruptcy :bankruptcy="commitment.bankruptcies"  :bankruptcy-legal-cases="bankruptcyLegalCases"></bankruptcy>
        <trade-refferences :trade-refferences="commitment.trade_references" :trade-reference-resp="reportData.trade_reference_resp"></trade-refferences>
        <historical-enquiry :historicalEnquiry="reportData.history"></historical-enquiry>
			</div>
    </div>
</template>
<script>
		import { Collapse, CollapseItem } from 'element-ui'
    import LoanInformation from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/LoanInformation'
    import SummaryCcris from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/SummaryCCRIS'
    import MissedPaymentHistory from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/MissedPayment'
    import TradeRefferences from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/TradeRefferences'
    import SpecialAttention from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/SpecialAttention'
    import LegalSts from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/LegalSts'
    import LegalCases from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/LegalCases'
    import Bankruptcy from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/Bankruptcy'
    import AkpkCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/AkpkCard'
    import AngkasaReport from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/AngkasaReport'
    import CreditApplication from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/CreditApplication'
    import HistoricalEnquiry from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/HistoricalEnquiry'
    import PastEnquiryDetails from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/PastEnquiryDetails'
    import Directories from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/Directories'
    import Liabilities from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/Liabilities' 
    import CcrisSupplementary from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CommitmentCards/CcrisSupplementary' 

    export default {
        name: 'commitment',
        props: ['commitment','platform','reportData'],
        components: {
            LoanInformation,
            SummaryCcris,
            MissedPaymentHistory,
            TradeRefferences,
            SpecialAttention,
            LegalSts,
            LegalCases,
            Bankruptcy,
            AkpkCard,
            AngkasaReport,
            CreditApplication,
            HistoricalEnquiry,
            PastEnquiryDetails,
            Directories, 
            Liabilities,
            CcrisSupplementary,
						[Collapse.name]: Collapse,
						[CollapseItem.name]: CollapseItem,
        },
				data() {
					return {
						activeNames: ['cbm','ctos'],
					}
				},
    //NEW PART FOR AKPK ONLY
    computed: {
			akpkSubItems() {
				const subItems = []
				try {
					if (!this.commitment) return subItems
					const commitments = Array.isArray(this.commitment.commitments) ? this.commitment.commitments : (this.commitment.commitments ? [this.commitment.commitments] : [])
					commitments.forEach(c => {
						if (c && Array.isArray(c.commitment_sub_items)) {
							c.commitment_sub_items.forEach(si => {
								if (si && (si.commitment_status === 'k' || si.commitment_status === 'K')) {
									subItems.push(si)
								}
							})
						}
					})
				} catch (e) {
					// defensive - if structure is unexpected, return empty array
					return []
				}
				return subItems
			},
      lastCommitmentRecord() {
        if (!this.commitment || !Array.isArray(this.commitment.commitments)) return null
        const list = this.commitment.commitments
        return list.length > 0 ? list[list.length - 1] : null
      },
			commitmentsWithArrears() {
				const results = []
				try {
					if (!this.commitment) return results
					const commitments = Array.isArray(this.commitment.commitments) ? this.commitment.commitments : (this.commitment.commitments ? [this.commitment.commitments] : [])
					commitments.forEach(c => {
						// check main commitment monthly arrears
						const monthly = Array.isArray(c.commitment_monthly) ? c.commitment_monthly : (c.commitment_monthly ? [c.commitment_monthly] : [])
						const hasArrears = monthly.some(m => m && m.month_inst_arrears && m.month_inst_arrears !== '0' && m.month_inst_arrears !== '')
						if (hasArrears) results.push(c)

						// check sub-items
						if (Array.isArray(c.commitment_sub_items)) {
							c.commitment_sub_items.forEach(si => {
								const siMonthly = Array.isArray(si.commitment_monthly) ? si.commitment_monthly : (si.commitment_monthly ? [si.commitment_monthly] : [])
								const siHasArrears = siMonthly.some(m => m && m.month_inst_arrears && m.month_inst_arrears !== '0' && m.month_inst_arrears !== '')
								if (siHasArrears) results.push(si)
							})
						}
					})
				} catch (e) {
					// defensive - return what we've collected so far
					return results
				}
				return results
			},
      // Replace the bankruptcyLegalCases computed property with this:
      bankruptcyLegalCases() {
        if (!this.reportData || !this.reportData.legal_cases_resp) return [];
        
        const legalCases = Array.isArray(this.reportData.legal_cases_resp) 
          ? this.reportData.legal_cases_resp 
          : [this.reportData.legal_cases_resp];
        
        return legalCases.filter(caseItem => 
          caseItem && 
          caseItem.title && 
          caseItem.title.toUpperCase() === 'BANKRUPTCY - RECEIVING OR ADJUDICATION ORDER ISSUED'
        );
      },
		},
    mounted() {
      // console.log('Report Data:', this.reportData.ccris_supplementary)
      //  console.log('Initial akpkSubItems:', this.akpkSubItems)
    }
    }
</script>